import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { getQueryStringFromObject, ListServerPaginationStateModel } from '../../../../../common';
import { Observable } from 'rxjs';
import { ShipmentSapDeliveryListSearchCriteria, ShipmentSapDeliveryModel } from '../../../../../common/models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderSapDeliveriesService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderSapDeliveries(
    searchCriteria: ShipmentSapDeliveryListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<ShipmentSapDeliveryModel>> {
    return this.http
      .withLoading()
      .get<ListServerPaginationStateModel<ShipmentSapDeliveryModel>>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.SapDeliveries
        }?${getQueryStringFromObject(searchCriteria.transportOrderIdView)}&page=${searchCriteria.page}&size=${
          searchCriteria.size
        }`,
      );
  }
}
